import React from "react";
import moment from "moment";

import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { TableColumnDef } from "../../components/DataTable";

type Props = {
  deleteRatingClickHandler: ({ row }: { row: any }) => void;
  canDelete: boolean;
};

export const getColumns = ({ deleteRatingClickHandler, canDelete }: Props): TableColumnDef[] => [
  {
    header: "Benutzer:in",
    render: (row: any) =>
      row?.userId?.firstName ? row?.userId?.firstName : "-",
    getValue: (row: any) => row?.userId?.firstName,
  },
  {
    header: "E-Mail",
    render: (row: any) =>
      row?.userId?.emailId ? row?.userId?.emailId : "-",
    getValue: (row: any) => row?.userId?.emailId,
  },
  {
    header: "Score 1-5",
    render: (row: any) => (
      <Chip label={row?.rating} color="success" size="small" />
    ),
    getValue: (row: any) => row?.rating,
  },
  {
    header: "Datum",
    render: (row: any) => moment(row?.createdAt).format("DD.MM.YYYY"),
    getValue: (row: any) => row?.createdAt,
  },
  {
    header: "Beschreibung",
    render: (row: any) => row?.ratingDescription || "-",
    getValue: (row: any) => row?.ratingDescription,
  },
  {
    header: "Einstellungen",
    render: (row: any) => (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {canDelete && (
          <Tooltip title="löschen Bewertung" arrow>
            <IconButton size="small" color="error" onClick={() => deleteRatingClickHandler({ row })}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
